<template>
  <section>
    <div class="status"><h2 v-translate>Přiřazené služby</h2><h2>&nbsp;({{ entity.services.length }})</h2></div>
    <form>
      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="business-models-services">
          <table class="vypis" ref="table_with_action_line">
      <not-sorting-table-header
          :titles="tableTitles"
          :useRight="false"
          :dragDrop="true"
          :checkbox="true"
      />
      <tbody>
      <service-row
          v-for="entity in entity.services"
          :entity="entity"
          :key="entity.id"
          :selectedEntities="selectedEntities"
          @input="select"
      />
      <tr v-if="!entity.services || entity.services.length === 0">
        <td colspan="4">{{ $gettext("Nebyly přiřazeny žádné služby.") }}</td>
      </tr>
      </tbody>
    </table>
        </div>
      </div>
    <local-list-action-line
        :entities="entity.services"
        :selected-entities="selectedEntities"
        :multiple-action-options="multipleActionOptions"
        table-id="business-models-services"
        @select-all="toggleSelectAll"
        @run-multiple-action="runMultipleAction"
    ></local-list-action-line>
    </form>
  </section>
</template>

<script>
import NotSortingTableHeader from "@/components/common/NotSortingTableHeader"
import localTable from "@/components/mixins/local-table"
import ServiceRow from "./ServiceRow";

	export default {
		name: "Services",
    mixins: [localTable],
    components: {NotSortingTableHeader, ServiceRow},
		props: {
			entity: Object,
			errorMessages: {
				type: [Array, Object],
				default: function () {
					return []
				},
			},
		},
    computed:{
      tableTitles() {
        return [
          this.$gettext('Název služby'),
          this.$gettext('Operátor'),
        ]
      },
      entities(){
        return Object.values(this.entity.services);
      },
      csvHeaders() {
        return {
          'name': {name: this.$gettext('Název služby')},
          'operator_name': {name: this.$gettext('Operátor')},
        }
      }
    },
	}
</script>



// WEBPACK FOOTER //
// src/components/views/businessModels/tabs/ServiceList.vue